/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { AddServiceProviderTypes } from "shared/interface/types";

const initialState: { ServiceProvider: AddServiceProviderTypes } = {
  ServiceProvider: {
    name: "",
    contactNumber: "",
    email: "",
    address: "",
    website: "",
    logo: "",
    id: "",
    cityId: 0,
    ntn: 0
  }
};

const serviceProviderSlice = createSlice({
  name: "serviceProvider",
  initialState,
  reducers: {
    AddServiceProvider: (state, action) => {
      state.ServiceProvider = action.payload;
    },
    DeleteServiceProvider: state => {
      state.ServiceProvider = initialState.ServiceProvider;
    }
  }
});

export const { AddServiceProvider, DeleteServiceProvider } = serviceProviderSlice.actions;
export default serviceProviderSlice.reducer;

export const getServiceProvider = (state: RootState) => state.serviceProvider;
